import * as _ from 'underscore'

export type TranslationCategory = 'Forum' | 'Control' | 'Common' | 'forum.mail.useractivation' | 'forum.mail.useractivated'

type PhraseMap = Record<string, string>
export interface TranslationsDict {
  [category: string]: PhraseMap
}

export type TranslationParameters = {
  [key: string]: string|number
} | undefined

function hasTranslations (w: any): w is {translations: TranslationsDict} {
  return 'translations' in w && !!w
}

let translationsDict: TranslationsDict = typeof window !== 'undefined' && hasTranslations(window) ? window.translations : {}

function parseSingularPlural (translation: string, param: unknown): string {
  if (translation.match('::phrase::')) return translation
  const translationSingularPlural = translation.split('|')
  if (param === 1) {
    return _.first(translationSingularPlural) || ''
  }
  return _.last(translationSingularPlural) || ''
}

function getTranslationFromDict (first: TranslationsDict, second: TranslationsDict, category: string, key: string) {
  const translation = (first[category] || {})[key]
  if (translation) return translation
  return (second[category] || {})[key]
}

function translateInternal (category: TranslationCategory, key: string, params: TranslationParameters, defaultTranslationDict: TranslationsDict|null = null) {
  params = params || {}

  const translationFromDict = getTranslationFromDict(defaultTranslationDict || {}, translationsDict, category, key)
  const hasTranslation = !!translationFromDict
  let translation = translationFromDict || key

  translation = parseSingularPlural(
    translation,
    parseInt(`${_.first(_.values(params)) || ''}`, 10)
  )

  _.each(params, function (value: string|number|undefined, paramKey: string) {
    translation = translation.split('{' + paramKey + '}').join(`${value || ''}`)
  })

  if (!hasTranslation) {
    translation = category + '|' + translation
  }

  return { translation, hasTranslation }
}

export const addTranslation = function (category: TranslationCategory, key: string, translation: string) {
  translationsDict[category] = translationsDict[category] || {}
  translationsDict[category][key] = translation
}

export const addTranslationDict = function (dict: TranslationsDict | undefined) {
  if (!dict) return
  for (const category in dict) {
    translationsDict[category] = Object.assign({}, translationsDict[category], dict[category])
  }
}

export const translateOrEmpty = function (category: TranslationCategory, key: string, params?: TranslationParameters, defaultTranslationDict: TranslationsDict|null = null) {
  const { hasTranslation, translation } = translateInternal(category, key, params, defaultTranslationDict)
  if (!hasTranslation) return ''
  return translation
}

export const translate = function (category: TranslationCategory, key: string, params?: TranslationParameters) {
  return translateInternal(category, key, params).translation
}

export const clearTranslations = function () {
  translationsDict = {}
}

export const t = translate

export default {
  addTranslation,
  addTranslationDict,
  translateOrEmpty,
  translate,
  clearTranslations,
  // short alias
  t: translate
}
